import { LandingTopWidget } from '../../organisms/landing';
import { InternalDashboardMain } from '../../organisms/internalDashboard/Main';
import { InternalDashboardSelector } from '../../organisms/internalDashboard/Selector';
import { LayoutSidebar } from '../../organisms/sidebar/LayoutSidebar';

const InternalDashboardPage = () => (
  <>
    <LandingTopWidget title='Admin Dashboard' />
    <LayoutSidebar>
      <InternalDashboardSelector>
        <InternalDashboardMain />
      </InternalDashboardSelector>
    </LayoutSidebar>
  </>
);

export default InternalDashboardPage;
